import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { getSampleDownloadUrl } from 'Redux/ducks/product';

function SampleFileSource({ file, type }) {
  const [sampleFile, setSampleFile] = useState('');

  useEffect(() => {
    if (type === 'audio' && document.getElementById('sample-audio-player')) document.getElementById('sample-audio-player').load();
    if (type === 'video' && document.getElementById('sample-video-player')) document.getElementById('sample-video-player').load();
    const getFile = async (fileId) => {
      const { signedGetUrl } = await getSampleDownloadUrl(fileId);
      setSampleFile(signedGetUrl);
    };

    getFile(file._id);
  });

  if (!sampleFile) return false;

  return (
    <source src={sampleFile} type={`${type}/${file.format}`} />
  );
}

SampleFileSource.propTypes = {
  file: PropTypes.shape({}).isRequired,
  type: PropTypes.string,
};

SampleFileSource.defaultProps = {
  type: '',
};

export default SampleFileSource;
